import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from '../base.component';
import { SharedService } from '../shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, SelectItem, MultiSelectModule } from 'primeng/primeng';
import { MapView, Severities } from '../shared.model';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';

declare var google: any;
declare var Microsoft: any;

@Component({
    selector: 'map-lookup',
    templateUrl: 'map-lookup.component.html'
})

export class MapLookUpComponent extends BaseComponent implements OnInit {

    @Input() mapView: MapView;
    @Output() Close = new EventEmitter();
    isOpenMap: boolean = false;
    map: any;
    address: string;
    fields: any;
    constructor(protected sharedService: SharedService, protected translate: TranslateService,
        private confirmationService: ConfirmationService, private datePipe: DatePipe, private _fb: FormBuilder) {
        super(sharedService, translate);


    }

    ngOnInit() {
        this.LoadMap(this.mapView);
    }
    openMapPopup() {

        this.isOpenMap = true;
        this.LoadMap(this.mapView);
    }
    // ngAfterViewInit() {

    //     this.LoadMap(this.mapView);
    // }
    closePopup() {
        this.Close.emit();
    }
    SetAddress() {
        debugger;
        this.Close.emit(this.fields);
    }
    LoadMap(m: MapView) {
        debugger;
        if (m != null) {
            if (super.globalInfo().MapId == "1")
                this.BingMap(this.mapView)
            if (super.globalInfo().MapId == "2")
                this.GoogleMap(this.mapView);
        }
    }

    GoogleMap(m: MapView) {

        var lattitude = 0;
        var langitude = 0;
        if (this.mapView != null) {

            if ((this.mapView.UserLat != null && this.mapView.UserLat != 0) && (this.mapView.UserLon != null && this.mapView.UserLon != 0)) {
                lattitude = this.mapView.UserLat;
                langitude = this.mapView.UserLon;
            }
            else if ((this.mapView.ZipLat != null && this.mapView.ZipLat != 0) && (this.mapView.ZipLon != null && this.mapView.ZipLon != 0)) {
                lattitude = this.mapView.ZipLat;
                langitude = this.mapView.ZipLon;
            }
            else if ((this.mapView.MapLat != null && this.mapView.MapLat != 0) && (this.mapView.MapLon != null && this.mapView.MapLon != 0)) {
                lattitude = this.mapView.MapLat;
                langitude = this.mapView.MapLon;
            }
        }
        var position = { lat: lattitude, lng: langitude };

        if (lattitude == 0 && langitude == 0) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: this.mapView.Country }, (results, status) => {
                if (status === "OK") {

                    position = results[0].geometry.location
                }
                this.address = this.mapView.Country;
                this.loadGoogle(position);

            });
        }
        else
            this.loadGoogle(position);


        //let geocoder = new google.maps.Geocoder();
        // var infowindow = new google.maps.InfoWindow({
        //     content: ''
        // });
        // geocoder.geocode({ 'location': position }, (results, status) => {
        //     if (results.length == 0) {
        //         this.address = "unknown location";
        //         return null;
        //     }
        //     this.address = results[0].formatted_address;
        //     this.fields = results[0];
        //     var contentString = '<div id="content">' +
        //         '<div id="siteNotice">' +
        //         '<span>' + this.address + '</span><br />' +
        //         '</div>' +
        //         '</div>';
        //     infowindow.setContent(contentString);
        // });

    }
    loadGoogle(position) {
        this.map = new google.maps.Map(document.getElementById('map-lookup'), {
            zoom: 13,
            center: position
        });
        var marker = new google.maps.Marker({
            position: position,
            map: this.map,
            draggable: true,
            title: 'Click to zoom'
        });

        var contentString = '';
        if (this.mapView.AddresLine1) {
            contentString = '<div id="content">' +
                '<div id="siteNotice">' +
                '<h5>Customer Address</h5>' +
                '<span>' + this.mapView.AddresLine1 + '</span><br />' +
                '<span>' + this.mapView.AddresLine2 + '</span><br />' +
                '<span>' + this.mapView.Cityame + ',</span><br />' +
                '<span>' + this.mapView.ZipCode + ',</span><br />' +
                '</div>' +
                '</div>';
        }
        else {
            contentString = '<div id="content">' +
                '<div id="siteNotice">' +
                '<span>' + this.mapView.Country + '</span><br />' +
                '</div>' +
                '</div>';
        }


        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });
        if (this.mapView.AddresLine1)
            infowindow.open(this.map, marker);

        // marker.addListener('click', function () {
        //     infowindow.open(this.map, marker);
        // });
        marker.addListener('dragend', () => {
            debugger;
            var position = marker.getPosition();
            let geocoder = new google.maps.Geocoder();
            var latlng = { lat: position.lat(), lng: position.lng() };
            geocoder.geocode({ 'location': latlng }, (results, status) => {
                if (results.length == 0) {
                    this.address = "unknown location";
                    return null;
                }
                this.address = results[0].formatted_address;
                this.fields = results[0];
                var contentString = '<div id="content">' +
                    '<div id="siteNotice">' +
                    '<span>' + this.address + '</span><br />' +
                    '</div>' +
                    '</div>';
                infowindow.setContent(contentString);
            });
        });
    }
    BingMap(m: MapView) {


        this.sharedService.getMapKey(super.globalInfo().MapKey).subscribe(res => {
            if (res.Message.Severity == Severities.success) {
                var lattitude = 0;
                var langitude = 0;
                if (this.mapView != null) {

                    if ((this.mapView.UserLat != null && this.mapView.UserLat != 0) && (this.mapView.UserLon != null && this.mapView.UserLon != 0)) {
                        lattitude = this.mapView.UserLat;
                        langitude = this.mapView.UserLon;
                    }
                    else if ((this.mapView.ZipLat != null && this.mapView.ZipLat != 0) && (this.mapView.ZipLon != null && this.mapView.ZipLon != 0)) {
                        lattitude = this.mapView.ZipLat;
                        langitude = this.mapView.ZipLon;
                    }
                    else if ((this.mapView.MapLat != null && this.mapView.MapLat != 0) && (this.mapView.MapLon != null && this.mapView.MapLon != 0)) {
                        lattitude = this.mapView.MapLat;
                        langitude = this.mapView.MapLon;
                    }
                }

                var map = new Microsoft.Maps.Map(
                    document.getElementById('map-lookup'),
                    {
                        credentials: res.Data,
                        //credentials: 'AnuBe28uEPfefIw5vrrkNEPdDuDbv0u5-ZTcpW9PFWQJpZ7QdSXM9WwrWBjlJxB1',
                        // center: new Microsoft.Maps.Location(51.50632, -0.12714),
                        center: new Microsoft.Maps.Location(lattitude, langitude),
                        mapTypeId: Microsoft.Maps.MapTypeId.ROADMAP,
                        zoom: 15
                    });
                var contentString = '<div id="content">' +
                    '<div id="siteNotice">' +
                    //'<h5>Customer Address</h5>' +
                    '<span>' + this.mapView.AddresLine1 + '</span><br />' +
                    '<span>' + this.mapView.AddresLine2 + '</span><br />' +
                    '<span>' + this.mapView.Cityame + ',</span><br />' +
                    '<span>' + this.mapView.ZipCode + ',</span><br />' +
                    '</div>' +
                    '</div>';
                var pushpinOptions = { draggable: true };
                var pushPin = new Microsoft.Maps.Pushpin(map.getCenter(), pushpinOptions);

                if (lattitude == 0 && langitude == 0) {
                    Microsoft.Maps.loadModule('Microsoft.Maps.Search', () => {
                        var searchManager = new Microsoft.Maps.Search.SearchManager(map);
                        searchManager.geocode({
                            bounds: map.getBounds(),
                            where: this.mapView.Country,
                            callback: (answer, userData) => {
                                debugger;
                                map.setView({ bounds: answer.results[0].bestView });
                                pushPin = new Microsoft.Maps.Pushpin(answer.results[0].location, pushpinOptions);
                                this.address = this.mapView.Country;
                                contentString = this.address;
                                this.loadBing(map, pushPin, contentString);
                            }
                        });
                    });
                }
                else {

                    // var latlon = new Microsoft.Maps.Location(lattitude, langitude);
                    // var pushPin = new Microsoft.Maps.Pushpin(latlon);
                    this.loadBing(map, pushPin, contentString);

                }

            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[3],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                    detail: this.translate.instant("INVALIDKEY")
                });
                return;
            }
        });

    }

    loadBing(map, pushPin, contentString) {
        var infowindow = new Microsoft.Maps.Infobox({
            title: 'Address',
            description: contentString,
            visible: true
        });

        pushPin.metadata = {

            description: contentString
        };
        map.entities.push(pushPin);
        infowindow.setMap(map);
        Microsoft.Maps.Events.addHandler(pushPin, 'click',
            (e) => {
                debugger;
                infowindow.setOptions({
                    //Use the location of where the mouse was clicked to position the infobox.
                    location: e.target.getLocation(),
                    description: e.target.metadata.description,
                    visible: true
                });
            });
        Microsoft.Maps.Events.addHandler(pushPin, 'dragend',
            (e) => {
                debugger;
                Microsoft.Maps.loadModule('Microsoft.Maps.Search', () => {
                    var searchManager = new Microsoft.Maps.Search.SearchManager(map);
                    searchManager.reverseGeocode({
                        location: new Microsoft.Maps.Location(e.location.latitude, e.location.longitude),
                        callback: (answer, userData) => {
                            debugger;
                            map.setView({ bounds: answer.bestView });
                            infowindow.setOptions({
                                //Use the location of where the mouse was clicked to position the infobox.
                                location: e.location,
                                description: answer.name,
                                visible: true
                            });
                            this.address = answer.name;
                            this.fields = answer;
                        }
                    });
                });
            });
    }

}

